import React, { useEffect, useState } from "react";
import { socket } from "../utils/customFn";

function SocketClient(orderId = 1, toChatWith = 2, customerId = 3) {
  const [messageText, setMessageText] = useState("");
  const [imageFile, setImageFile] = useState(null);


  function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      const base64 = result.split(",")[1]; // remove data:image/png;base64, prefix
      resolve(base64);
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}


  const sendMessage = async (type) => {
    if (!socket || !socket.connected) {
      console.warn("Socket not connected");
      return;
    }

    if (!messageText.trim() && !imageFile) {
      return;
    }

    let messageData;

    if (type == "1" && imageFile) {
      const imageB64 = await readFileAsBase64(imageFile);
      messageData = {
        message: imageB64,
        userid: customerId.toString(),
        to: toChatWith,
        type: "1",
        order_id: orderId,
      };
    } else {
      messageData = {
        message: messageText.trim(),
        userid: customerId.toString(),
        to: toChatWith,
        type: "0",
        order_id: orderId,
      };
    }

    socket.emit("messages", messageData);
    console.log("Message sent:", messageData);

    // Reset input
    setMessageText("");
    setImageFile(null);
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Type message..."
        value={messageText}
        onChange={(e) => setMessageText(e.target.value)}
      />
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImageFile(e.target.files[0])}
      />
      <button onClick={() => sendMessage("0")}>Send Text</button>
      <button onClick={() => sendMessage("1")}>Send Image</button>
    </div>
  );
}

export default SocketClient;